import React from "react";
import ReportsMain from "../../components/reports/ReportsMain";
import { RODEO_PAGE_NAME } from "src/_config/site_statics";
import Sidebar from "src/components/common/Sidebar";
import Header from "src/components/common/Header";
import Footer from "src/components/common/Footer";

export default function Reports() {
  //return <ReportsMain />;
  return(<>
     <Header variant="topbar" />
      <Sidebar page={RODEO_PAGE_NAME.DASHBOARD} />
      <ReportsMain />
      
    <Footer variant="dashboard" />
    </>)
}